<template>
  <div>
    <v-dialog width="1000" v-model="modal" scrollable>
      <v-card>
        <v-card-title style="width: 800px" class="mx-auto">
          Editar pago

          <v-spacer></v-spacer>

          <v-btn @click.stop="modal = false" icon>
            <v-icon>
              mdi-close
            </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <edit
            :tid="tax.id"
            :id="tax.taxableId"
            :objectType="tax.taxableType"
            @created="reload"
            dialog
          ></edit>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-card class="rounded-lg" outlined>
      <v-card-text
        class="text-subtitle-1 black--text py-2 d-flex flex-row justify-space-between align-center"
      >
        <div>
          {{ tax.name }}
        </div>
        <div>
          <v-dialog v-model="dialog" width="500">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="red lighten-2"
                class="ml-3"
                icon
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>
                  mdi-delete
                </v-icon>
              </v-btn>
            </template>

            <v-card>
              <v-card-title class="text-h5 justify-center">
                Eliminar impuesto
              </v-card-title>

              <v-card-text>
                ¿Está seguro de que desea eliminar el impuesto? Esta acción
                <span class="font-weight-bold">no se puede deshacer.</span>
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="dialog = false">
                  Cancelar
                </v-btn>
                <v-btn color="error" text @click="deleteTax">
                  Confirmar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-btn icon color="primary" @click="openEdit">
            <v-icon>
              mdi-pencil
            </v-icon>
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import Edit from "@/components/taxes/Create";

import { DeleteTax } from "@/graphql/mutations/taxes";

export default {
  data: () => ({
    dialog: false,
    modal: false
  }),

  props: {
    tax: {
      required: true,
      type: Object
    }
  },

  methods: {
    deleteTax() {
      this.$apollo
        .mutate({
          mutation: DeleteTax,
          variables: {
            input: {
              id: this.tax.id
            }
          }
        })
        .then(res => {
          this.dialog = false;
          this.$emit("reload");
        });
    },

    openEdit() {
      this.modal = true;
    },

    reload() {
      this.modal = false;
      this.$emit("reload");
    }
  },

  components: {
    Edit
  }
};
</script>
